import Link from 'next/link'
import PropTypes from 'prop-types'

const MetaMenu = (props) => {
  const { topBarLinks } = props

  return (
    <div className="MetaMenu">
      <div className="MetaMenu-inner">
        <div className="MetaMenu-outbound">
          <ul className="MetaMenu-list">
            {topBarLinks &&
              topBarLinks.map((link, index) => {
                return (
                  <li className="MetaMenu-item" key={`MetaMenu-item--${index}`}>
                    {link.topBarLink.type === 'url' && (
                      <a
                        className="MetaMenu-link"
                        href={link.topBarLink.url || '#'}
                        target={link.topBarLink.target || '_blank'}
                        rel="noreferrer"
                      >
                        <span className="MetaMenu-label">
                          <span className="MetaMenu-copy">{link.topBarLabel || ''}</span>
                        </span>
                      </a>
                    )}
                    {link.topBarLink.type === 'entry' && (
                      <Link href={`../${link.topBarLink.element.uri}`}>
                        <a className="MetaMenu-link">
                          <span className="MetaMenu-label">
                            <span className="MetaMenu-copy">{link.topBarLabel || ''}</span>
                          </span>
                        </a>
                      </Link>
                    )}
                  </li>
                )
              })}
          </ul>
        </div>
      </div>
    </div>
  )
}

MetaMenu.propTypes = {
  topBarLinks: PropTypes.array
}

export default MetaMenu
